import * as React from "react";
import Popover from "@mui/material/Popover";
import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";

export default function MyPopover({ onClick, options }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton size="small" onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List>
          {options.map((value) => (
            <ListItem key={value.name} disablePadding>
              <ListItemButton
                onClick={() => {
                  onClick(value.status);
                  handleClose();
                }}
              >
                <ListItemText
                  primary={value.name}
                  primaryTypographyProps={{ fontSize: "14px" }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Popover>
    </div>
  );
}
